export const BACKEND_URL =
  import.meta.env.VITE_BACKEND_URL || "https://api.reeva.care";

export const TOKEN_KEY = "token";
export const EXPIRATION_KEY = "expirationTime";
export const TOKEN_TTL_MS = 14_400_000; // 4 hours, same as mobile
